/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Rest_Api_S5_TitleInputs */

const en_guide_json_rest_api_s5_title = /** @type {(inputs: Guide_Json_Rest_Api_S5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Best Practices for JSON APIs`)
};

const ko_guide_json_rest_api_s5_title = /** @type {(inputs: Guide_Json_Rest_Api_S5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON API 모범 사례`)
};

const ja_guide_json_rest_api_s5_title = /** @type {(inputs: Guide_Json_Rest_Api_S5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON APIのベストプラクティス`)
};

/**
* | output |
* | --- |
* | "Best Practices for JSON APIs" |
*
* @param {Guide_Json_Rest_Api_S5_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_rest_api_s5_title = /** @type {((inputs?: Guide_Json_Rest_Api_S5_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Rest_Api_S5_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_rest_api_s5_title(inputs)
	if (locale === "ko") return ko_guide_json_rest_api_s5_title(inputs)
	return ja_guide_json_rest_api_s5_title(inputs)
});